document.addEventListener('DOMContentLoaded', (event) => {
    const stickyElement =  document.querySelector('[data-sticky-element]');
    let headerHeight = 0;
    if(document.querySelector("[data-site-header]") != null){
        headerHeight = document.querySelector("[data-site-header]").offsetHeight + 1;
    }
    let currentOffsetTopHeader = stickyElement.getBoundingClientRect().top;
    if (currentOffsetTopHeader <= headerHeight) {
        stickyElement.classList.add("open");
    } else {
        stickyElement.classList.remove("open");

    }


    window.addEventListener('scroll', () => {
        const currentOffsetTop = document.querySelector('[data-sticky-element]').getBoundingClientRect().top;
        if(document.querySelector("[data-site-header]") != null){
            headerHeight = document.querySelector("[data-site-header]").offsetHeight
        }
        
        if (currentOffsetTop <= headerHeight + 1) {
            stickyElement.classList.add("open");
        } else {
            console.log('Element is not sticky');
            stickyElement.classList.remove("open");

        }
    });


    if (document.querySelectorAll('[data-scroll-id]').length > 0) {
        document.querySelectorAll('[data-scroll-id]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                let scrollDistance = 0

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                let currentAttribute = targetElement.getAttribute('id');
                if(currentAttribute == "Bookbinding" ){
                    scrollDistance = targetElement.getBoundingClientRect().top - document.querySelector("[data-site-header]").getBoundingClientRect().top;

                    window.scrollTo({
                        top: scrollDistance,
                        behavior: 'smooth'
                    });
                }else{
                    targetElement.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
    document.querySelectorAll('[heading_text]').forEach(ele=>{
        let has_data = ele.nextElementSibling
        let heading_text = ele.getAttribute('id');
        if(has_data){
            if(has_data.hasAttribute("author") == false){
                document.querySelector(`[data-scroll-id="${heading_text}"]`).closest('li').remove();
                ele.remove();
            }
        }else{
            document.querySelector(`[data-scroll-id="${heading_text}"]`).closest('li').remove();
            ele.remove();
        }
      })
});